const Element = require("components/abstract/Element");
const PropTypes = require("prop-types");
const TableHead = require("components/layouts/headers/TableHead");
const {Decorators: {Injector}} = require("core");
const Auth = require("services/Auth");

const {searchObject, pluckKeysExcept, decodeObservable} = require("helpers/object");
class BaseColumn extends Element {

    static get propTypes() {
        return {
            name: PropTypes.string,
            class: PropTypes.string,
            default: PropTypes.any,
            checked: PropTypes.bool,
            options: PropTypes.array,
            label: PropTypes.string,
            enum: PropTypes.string,
            data_index: PropTypes.number,
            data: PropTypes.object,
            sortable: PropTypes.bool,
            plain: PropTypes.bool,
            type: PropTypes.string,
            sort_dir: PropTypes.string,
            sort_zero_last: PropTypes.bool,
            header: PropTypes.bool,
            sort: PropTypes.func,
            formatter: PropTypes.func,
            sorted_col: PropTypes.object,
            alignment: PropTypes.string,
            resource: PropTypes.string,
            operation: PropTypes.string,
        };
    }

    static get defaultProps() {
        return {
            data: {},
            data_index: 0,
            class: '',
            default: null,
            enum: null,
            checked: false,
            sortable: false,
            plain: false,
            options: [],
            type: 'string',
            sort_dir: 'desc',
            sort_zero_last: false,
            header: false,
            sorted_col: {},
            alignment: 'left',
        };
    }

    get sortable() {
        return this.props.sortable;
    }

    get label() {
        if (typeof(this.props.label) === 'undefined' || this.props.label === null) {
            return this.props.name;
        }
        return this.props.label;
    }

    get sort() {
        return this.props.sort;
    }

    get data() {
        return this.props.data;
    }

    get plain() {
        return this.props.plain;
    }

    get name() {
        return this.props.name;
    }

    get sort_slug() {
        if(this.props.sort_slug){
            return this.props.sort_slug;
        }
        return this.name;
    }

    get type() {
        return this.props.type;
    }

    get class() {
        return this.classNames;
    }

    get value() {

        if(typeof this.props.value === 'function') {
            return this.props.value(this);
        }

        let value = this.getDataValue(this.name, this.props.default);

    	if(value === ''){
    	    return this.props.default;
        }
    	return value;
    }

    get formatted_value() {
        return this.format(this.modify(this.value));
    }

    get options() {
        return this.props.options;
    }

    get defaultClassNames() {
        return [
            'column'
        ];
    }

    get alignment() {
        if(this.props.alignment){
            return this.props.alignment;
        }
        return 'left';
    }

    get rowClass() {
        return this.resolveProp('rowClass');
    }

    get extraClassName () {
        return '';
    }

    getDataValue(name, defaultValue) {
        return searchObject(this.data, name, defaultValue);
    }

    shouldRender(header = false) {
        const {resource, operation, data} = this.props;

        if (!resource || !operation) return true;

        if (header) return Auth.can(operation, resource);

        return Auth.can(operation, resource, data);
    }

    resolveProp = (propName, defaultValue = null) => {

        if (typeof(this.props[propName]) !== 'undefined') {

            if (typeof(this.props[propName]) === 'function') {
                if (this.data === null || typeof(this.data) === 'undefined') {
                    return null;
                }
                return this.props[propName](this.data);
            }

            return this.props[propName];
        }

        return (defaultValue === null && this.defaultProps && !!this.defaultProps[propName]) ?
            this.defaultProps[propName] :
            defaultValue;
    };

    modify(value) {
        if (typeof(this.props.modifier) === 'function') {
            return this.props.modifier(value);
        }
        return value;
    }

    format(value) {
        if (typeof(this.props.formatter) === 'function') {
            return this.props.formatter(value);
        }
        return value;
    }

    renderSortIcon(sortable) {
        if (sortable) {
            return (
                <div className={`sort-cont ${this.props.sorted_col.name === this.name ? 'active' : ''}`}>
                    <img src={null}
                         className="filter-arrow"/>
                </div>
            )
        }
    }

    renderHeaderContent() {
        return (
            <React.Fragment>
                {this.label}
            </React.Fragment>
        );
    }

    renderHeader() {
        if (!this.shouldRender(true)) return null;

        return (
            <TableHead
                key={this.name}
                className={(this.class) + " " + (this.sortable ? " " : "no-select ") + this.name}
                slug={this.sort_slug}
                descending={true}
                action={this.sort}
                sortable={this.sortable}
                alignment={this.alignment}
            >
                {this.renderHeaderContent()}
            </TableHead>
        );
    }

    renderPlain() {
        if(this.plain){
            return <span>{this.label}</span>;
        }
    }

    renderCellContent() {
        return (
            <React.Fragment>
                {this.formatted_value}
            </React.Fragment>
        )
    }

    renderCell() {
        if (!this.shouldRender(true)) return null;
        const content = this.shouldRender() ? this.renderCellContent() : null;

        return (
            <td className={`${this.name} ${this.class} ${this.rowClass} ${this.extraClassName}`} align={this.alignment} >
                {this.renderPlain()}
                {content}
            </td>
        );
    }

    render() {
        if (this.props.header) {
            return this.renderHeader();
        } else {
            return this.renderCell();
        }
    }

    /////////////////////////////////
    // Wrapped
    /////////////////////////////////

    static inject(stores = ["data", "store"]) {
        return Injector(stores)(this);
    }

}

module.exports = BaseColumn;
